<template>
  <transition name="bg-modal">
    <div
      v-if="visible"
      class="bg-modal-overlay"
      role="presentation"
      @click.self="close"
    >
      <div
        class="bg-lang-modal"
        role="dialog"
        aria-modal="true"
        :aria-label="$t('lang.title')"
        @keydown.esc.prevent="close"
      >
        <header class="bg-lang-modal__header">
          <h2 class="bg-lang-modal__title">{{ $t('lang.title') }}</h2>
          <button
            type="button"
            class="bg-lang-modal__close"
            :aria-label="$t('common.close')"
            @click="close"
          >
            <svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true">
              <path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
            </svg>
          </button>
        </header>

        <ul class="bg-lang-modal__list">
          <li v-for="item in locales" :key="item.code">
            <button
              type="button"
              class="bg-lang-modal__option"
              :class="{ 'bg-lang-modal__option--active': item.code === currentLocale }"
              @click="selectLocale(item.code)"
            >
              <span class="bg-lang-modal__badge" aria-hidden="true">{{ item.short }}</span>
              <span class="bg-lang-modal__label">{{ item.label }}</span>
              <span v-if="item.code === currentLocale" class="bg-lang-modal__check" aria-hidden="true">✓</span>
            </button>
          </li>
        </ul>
      </div>
    </div>
  </transition>
</template>

<script>
import { APP_LOCALES, setAppLocale } from '@/utils/locale'

export default {
  name: 'BlackGoldLangModal',
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      locales: APP_LOCALES
    }
  },
  computed: {
    currentLocale () {
      return this.$i18n.locale
    }
  },
  methods: {
    close () {
      this.$emit('close')
    },
    selectLocale (code) {
      if (code === this.currentLocale) {
        this.close()
        return
      }
      setAppLocale(code)
      this.$emit('change', code)
      this.close()
    }
  }
}
</script>
